module.exports = __webpack_public_path__ + "img/9-exterior-roof.50c48eb1.svg";